export const nav = (isNavToggled) => {

  const $body = $('body');
  const $header = $('.js-header');
  const $mobileNav = $('.js-mobile-nav');
  const btnToggleNav = '.js-toggle-mobile-nav';

  let brMed = 1024;

  const init = () => {
    bind();
  };

  const observer = new IntersectionObserver(
    ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
    {threshold: [1]}
  );

  window.addEventListener('resize', function() {
    if(window.innerWidth > brMed && isNavToggled ) {
      toggle();
    }
  });

  const bind = () => {
    $body.on('click', btnToggleNav, (e) => {
      e.preventDefault();
      toggle();
    });

    observer.observe(document.querySelector('.js-nav'));

  };

  const toggle = () => {
    if (isNavToggled) {
      $mobileNav.attr('aria-hidden',true);
      $body.attr('data-menu-open','false');
      $body.removeClass('no-scroll');
      // $header.addClass('is-partially-hidden');
    } else {
      $mobileNav.attr('aria-hidden',false);
      $body.attr('data-menu-open','true');
      $body.addClass('no-scroll');
      $header.removeClass('is-partially-hidden');
    }

    isNavToggled = !isNavToggled;

  };

  init();

  return {
    isNavToggled
  };

}
